import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, IconButton, useMediaQuery, Chip } from '@mui/material';
import { IconCaretRightFilled } from '@tabler/icons-react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { StringKeys } from '../../../resources/strings/StringKeys';
import CustomPagination from '../../../components/pagination/CustomPagination';
import InvoiceStatusCell from './components/InvoiceStatusCell';

const InvoicesTable = ({ invoices, customers, page, rowsPerPage, handleChangePage, handleChangeRowsPerPage }) => {
  const { t } = useTranslation();
  const isMobile = useMediaQuery('(max-width:600px)');
  const navigate = useNavigate();

  const findCustomerName = (customerId) => {
    const customer = customers.find(c => c.stripe_customer_id === customerId);
    return customer ? `${customer.first_name} ${customer.last_name}` : t(StringKeys.UNKNOWN_CUSTOMER);
  };

  const isProcessing = (invoice) => {
    return !invoice.number; // Consider invoice as processing until it has a number
  };

  const paginatedInvoices = rowsPerPage > 0
    ? invoices.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
    : invoices;

  return (
    <>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              {!isMobile && <TableCell style={{ fontWeight: 'bold' }}>{t(StringKeys.CUSTOMER)}</TableCell>}
              <TableCell style={{ fontWeight: 'bold' }}>{t(StringKeys.INVOICE_ID)}</TableCell>
              {!isMobile && <TableCell style={{ fontWeight: 'bold' }}>{t(StringKeys.AMOUNT)}</TableCell>}
              {!isMobile && <TableCell style={{ fontWeight: 'bold' }}>{t(StringKeys.STATUS)}</TableCell>}
              {!isMobile && <TableCell style={{ fontWeight: 'bold' }}>{t(StringKeys.DATE)}</TableCell>}
              {isMobile && <TableCell></TableCell>}
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedInvoices.map((invoice) => (
              <TableRow 
                key={invoice.id} 
                onClick={() => {
                  !isMobile && !isProcessing(invoice) && navigate(`/invoices/${invoice.id}`);
                }}
                style={{ cursor: !isMobile && !isProcessing(invoice) ? 'pointer' : 'default' }}
              >
                {!isMobile && <TableCell>{findCustomerName(invoice.customer_id)}</TableCell>}
                <TableCell>
                  {isProcessing(invoice) ? (
                    <Chip 
                      label={t(StringKeys.PROCESSING)}
                      color="warning"
                      size="small"
                    />
                  ) : invoice.number}
                </TableCell>
                {!isMobile && <TableCell>${(invoice.total / 100).toFixed(2)}</TableCell>}
                {!isMobile && (
                  <TableCell>
                    {isProcessing(invoice) ? (
                      <Chip 
                        label={t(StringKeys.PROCESSING)}
                        color="warning"
                        size="small"
                      />
                    ) : (
                      <InvoiceStatusCell refunded={invoice.refunded} status={invoice.status} t={t} />
                    )}
                  </TableCell>
                )}
                {!isMobile && <TableCell>{new Date(invoice.created_at.seconds * 1000).toLocaleDateString()}</TableCell>}
                {isMobile && 
                  <TableCell sx={{ textAlign: "end" }}>
                    {!isProcessing(invoice) && (
                      <IconButton
                        component={Link}
                        to={`/invoices/${invoice.id}`}
                        state={{ invoice }}
                        onClick={(e) => e.stopPropagation()}
                      >
                        <IconCaretRightFilled />
                      </IconButton>
                    )}
                  </TableCell>
                }
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <CustomPagination
        rowsPerPageOptions={[10, 25, 100, { label: 'All', value: -1 }]}
        component="div"
        count={invoices.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}      
      />
    </>
  );
};

export default InvoicesTable;
